<template>
    <div>
        <select name="" id="" class="p-1 border border-gray-400 w-fit rounded-sm" v-model="crmNextAction" @change="openForm">
            <option v-for="option in nextActionOptions" :key="option.value" :value="option.value" >{{ option.label }}</option>
        </select>
        <base-modal-small v-if="isCRMEventFormVisible" @close="closeCRMEventFormWithoutSaving">
          <template #header>
            <h2 class="text-lg">{{ company.company_name }} {{ company.id }} - Change CRM Next Action</h2>
          </template>
          <template #body>
            <div class="w-full p-1 h-[90%] overflow-auto">
                <div class="w-full flex flex-col">
                    <div class="w-full p-1 flex flex-col items-center mb-2">
                        <div>
                            Was the previous action "{{ previousAction }}" completed?
                        </div>
                    </div>
                    <div class="flex items-center justify-center">
                        <div class="flex items-center m-1">
                            <div class="mr-1">
                                Yes
                            </div>
                            <input type="radio" name="completedAction" :value="true" v-model="completedAction">
                        </div>
                        <div class="flex items-center m-1">
                            <div class="mr-1">
                                No
                            </div>
                            <input type="radio" name="completedAction" :value="false" v-model="completedAction">
                        </div>
                        <form action="" id="eventsForm" @submit.prevent="saveWithEvent"></form>                    
                    </div>
                    <transition
                    enter-active-class="transition duration-150 ease-out"
                    enter-from-class="transform origin-top scale-0"
                    enter-to-class="transform origin-top scale-1"
                    leave-active-class="transition duration-100 ease-in"
                    leave-from-class="transform origin-top scale-1"
                    leave-to-class="transform origin-top scale-0"
                    >
                        <div v-if="completedAction" class="transition duration-300 ease-in-out px-1 py-4 flex flex-col border-b">
                            <div class="w-full flex flex-col items-start space-y-2 px-2">
                                <div class="w-full flex justify-center mb-3">
                                    If so, add a CRM Detail here documenting the action for reporting purposes.
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="w-1/4 flex items-center p-1 bg-gray-100 rounded-l h-full border border-r-0 border-gray-300" for="" >
                                        Detail Name:
                                    </label>
                                    <select required form="eventsForm" v-model="eventFormData.action_id" class="  text-center p-1 border h-full w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="">
                                        <!-- <option value="">------</option> -->
                                        <option v-for="event in crmActionTypes" :key=event.id :value="event.id">{{ event.action_name }}</option>
                                    </select>
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="w-1/4 flex items-center p-1 bg-gray-100 rounded-l h-full border border-r-0 border-gray-300" for="" >
                                        Resolved Date:
                                    </label>
                                    <input  required form="eventsForm" v-model="eventFormData.resolved_date" id="crmNewActionDueDate" type="date"
                                        class="  text-center p-1 border h-full w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    >
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="w-1/4 flex items-center p-1 bg-gray-100 rounded-l h-full border border-r-0 border-gray-300" for="" >
                                        User:
                                    </label>
                                    <select v-model="eventFormData.user_id" id="crmNewActionUser"
                                        class=" p-1 border text-center w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        >
                                        <option value="">---User---</option>
                                        <!-- <option value=3>Scott Shedd</option> -->
                                        <option v-for="user in crmUsers" :key="user.id" :value="user.id">{{ user.first_name}} {{ user.last_name }}</option>
                                    </select>
                                </div>
                                <div class="w-full flex items-center">
                                    <textarea v-model="eventFormData.action_notes" id="notesInput" type="text" rows="3" placeholder="Notes"
                                        class=" col-span-4 p-1 border w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    ></textarea>
                                </div>
                                <div class="w-full flex justify-center items-center space-x-4">
                                    <!-- <base-button-affirmative>
                                        Save Next Action and Create Detail
                                    </base-button-affirmative> -->
                                </div>
                            </div>
                        </div>
                    </transition>
                    <div class="w-full p-1 flex flex-col items-center mb-2">
                        <div>
                            Would you like to make a new CRM Detail for {{ crmNextAction }}?
                        </div>
                    </div>
                    <div class="flex items-center justify-center">
                        <div class="flex items-center m-1">
                            <div class="mr-1">
                                Yes
                            </div>
                            <input type="radio" name="newDetail" :value="true" v-model="newDetail">
                        </div>
                        <div class="flex items-center m-1">
                            <div class="mr-1">
                                No
                            </div>
                            <input type="radio" name="newDetail" :value="false" v-model="newDetail">
                        </div>                    
                    </div>
                    <transition
                    enter-active-class="transition duration-150 ease-out"
                    enter-from-class="transform origin-top scale-0"
                    enter-to-class="transform origin-top scale-1"
                    leave-active-class="transition duration-100 ease-in"
                    leave-from-class="transform origin-top scale-1"
                    leave-to-class="transform origin-top scale-0"
                    >
                        <div v-if="newDetail" class="transition duration-300 ease-in-out px-1 py-4 flex flex-col border-b">
                            <div class="w-full flex flex-col items-start space-y-2 px-2">
                                <div class="w-full flex justify-center mb-3">
                                    If so, add a CRM Detail here for the next action.
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="w-1/4 flex items-center p-1 bg-gray-100 rounded-l h-full border border-r-0 border-gray-300" for="" >
                                        Detail Name:
                                    </label>
                                    <select required form="eventsForm" v-model="newDetailFormData.action_id" class="  text-center p-1 border h-full w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="">
                                        <!-- <option value="">------</option> -->
                                        <option v-for="event in crmActionTypes" :key=event.id :value="event.id">{{ event.action_name }}</option>
                                    </select>
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="w-1/4 flex items-center p-1 bg-gray-100 rounded-l h-full border border-r-0 border-gray-300" for="" >
                                        Due Date:
                                    </label>
                                    <input v-model="newDetailFormData.due_date" type="date"
                                        class="  text-center p-1 border h-full w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    >
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="w-1/4 flex items-center p-1 bg-gray-100 rounded-l h-full border border-r-0 border-gray-300" for="" >
                                        User:
                                    </label>
                                    <select v-model="newDetailFormData.user_id"
                                        class=" p-1 border text-center w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        >
                                        <option value="">---User---</option>
                                        <!-- <option value=3>Scott Shedd</option> -->
                                        <option v-for="user in crmUsers" :key="user.id" :value="user.id">{{ user.first_name}} {{ user.last_name }}</option>
                                    </select>
                                </div>
                                <div class="w-full flex items-center">
                                    <textarea v-model="newDetailFormData.action_notes" type="text" rows="3" placeholder="Notes"
                                        class=" col-span-4 p-1 border w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    ></textarea>
                                </div>
                                <div class="w-full flex justify-center items-center space-x-4">
                                    <!-- <base-button-affirmative>
                                        Save Next Action and Create Detail
                                    </base-button-affirmative> -->
                                </div>
                            </div>
                        </div>
                    </transition>

                    <div class="w-full flex justify-center mt-2">
                        <base-button-affirmative form="eventsForm">Save</base-button-affirmative>
                    </div>
                </div>
            </div>
          </template>
        </base-modal-small>
    </div>
</template>

<script>
    export default {
        name: "crm-status-cell"
    }
</script>

<script setup>
import { defineProps, defineEmits, watch, ref, reactive } from 'vue';
import { useStore } from 'vuex';
import { updateCrmNextAction, updateCrmNextActionAndAddEvent } from '@/services/Company';
import { getTodaysDateAsString } from '@/composables/formatDate';
import { useToast } from 'vue-toast-notification';

const store = useStore()
const $toast = useToast()

const props = defineProps({
    company: Object,
    crmActionTypes: Array,
    crmUsers: Array
})

const completedAction = ref(false)
const newDetail = ref(false)

function setCompletedAction(value) {
    completedAction.value = value
}

function setNewDetail(value){
    newDetail.value = value
}

const isCRMEventFormVisible = ref(false)
const actionCompleted = ref(true)

function closeCRMEventForm(){
    isCRMEventFormVisible.value = false
}

function closeCRMEventFormWithoutSaving(){
    crmNextAction.value = previousAction.value
    isCRMEventFormVisible.value = false
}

function getEventIdFromNextAction(crmNextAction){
    if(crmNextAction == "Send Initial Email"){
        return 2
    }
    if(crmNextAction == "Send Another Email"){
        return 1
    }
    if(crmNextAction == "Call"){
        return 9
    }
    if(crmNextAction == "Send 2nd Email"){
        return 3
    }
    if(crmNextAction == "Send 3rd Email"){
        return 4
    }
    if(crmNextAction == "Send 4th Email"){
        return 21
    }
    if(crmNextAction == "Cold Call 1"){
        return 5
    }
    if(crmNextAction == "Cold Call 2"){
        return 5
    }
    if(crmNextAction == "Call Again"){
        return 5
    }
    if(crmNextAction == "Not Now"){
        return 25
    }
    if(crmNextAction == "Submit IOI"){
        return 15
    }
    if(crmNextAction == "Submit LOI"){
        return 16
    }
}

const previousAction = ref(props.company.crm_next_action)

const crmNextAction = ref(props.company.crm_next_action)

const eventFormData = reactive({
    action_id: null,
    user_id: store.state.auth.user.id,
    created_by_id: store.state.auth.user.id,
    status: "Done",
    resolved_date: getTodaysDateAsString(),
    action_notes: "",
    company_id: props.company.id,
    campaign_id: props.company.campaign ? props.company.campaign.id : null
})

const newDetailFormData = reactive({
    action_id: null,
    user_id: store.state.auth.user.id,
    created_by_id: store.state.auth.user.id,
    status: "Done",
    due_date: getTodaysDateAsString(),
    action_notes: "",
    company_id: props.company.id,
    campaign_id: props.company.campaign ? props.company.campaign.id : null
})

const nextActionOptions = ref([
    {value: 'None', label: 'None'},
    {value: 'Determine Next Action', label: 'Determine Next Action'},
    {value: 'Scott to Follow-Up', label: 'Scott to Follow-Up'},
    {value: 'BA to Follow-Up', label: 'BA to Follow-Up'},
    {value: 'LG to Follow-Up', label: 'LG to Follow-Up'},
    {value: 'CB to Follow-Up', label: 'CB to Follow-Up'},
    {value: 'Send Initial Email', label:'Send Initial Email' },
    {value: 'Send Another Email', label: 'Send Another Email'},
    {value: 'Send LinkedIn InMail', label: 'Send LinkedIn InMail'},
    {value: 'Send Email on Acquisition', label: 'Send Email on Acquisition'},
    {value: 'Research Correct Email', label: 'Research Correct Email'},
    {value: 'Call', label: 'Call'},
    {value: 'Schedule Meeting', label: 'Schedule Meeting'},
    {value: 'Wait on Response', label: 'Wait on Response'},
    {value: 'Wait for Client Feedback', label: 'Wait for Client Feedback'},
    {value: 'Meet', label: 'Meet'},
    {value: 'Not Now', label: 'Not Now'},
    {value: 'Leave Alone', label: 'Leave Alone'},
    {value: 'Referral Source to Reach Out', label: 'Referral Source to Reach Out'},
    {value: "Send 2nd Email", label: "Send 2nd Email"},
    {value: "Send 3rd Email", label: "Send 3rd Email"},
    {value: "Send 4th Email", label: "Send 4th Email"},
    {value: "Cold Call 1", label: "Cold Call 1"},
    {value: "Cold Call 2", label: "Cold Call 2"},
    {value: "Call again", label: "Call again"},
    {value: "Periodic Check In", label: "Periodic Check In"},
    {value: "Submit IOI", label: "Submit IOI"},
    {value: "Submit LOI", label: "Submit LOI"},
])

watch(props, ()=>{
    previousAction.value = props.company.crm_next_action
    crmNextAction.value = props.company.crm_next_action
    actionCompleted.value = true
    completedAction.value = false
    newDetail.value = false
})

const emit = defineEmits(['refetch-companies'])

function openForm() {
    if(previousAction.value && props.company.campaign){
        isCRMEventFormVisible.value = true
        eventFormData.action_id = getEventIdFromNextAction(previousAction.value)
        newDetailFormData.action_id = getEventIdFromNextAction(crmNextAction.value)
    } else {
        saveWithoutEvent()
    }
}

async function saveWithEvent() {
    const token = store.state.auth.token
    const data = JSON.stringify({
        crm_next_action: crmNextAction.value,
        event_data: completedAction.value ? eventFormData : null,
        new_detail_data: newDetail.value ? newDetailFormData: null,
        crm_next_action_due_date: props.company.crm_next_action_due_date
    })
    const result = await updateCrmNextActionAndAddEvent(props.company.id, data, token)
    if(result.status == 200){
        $toast.open({
            message: 'Updated CRM Next Action and added event',
            type: 'success',
            duration: 5000
        })
        emit('refetch-companies')
        closeCRMEventForm()
    } else {
        $toast.open({
            message: 'Error, could not update CRM Next Action and add event',
            type: 'error',
            duration: 3000
        })
    }
}

async function saveWithoutEvent() {
    const token = store.state.auth.token
    const data = JSON.stringify({
        crm_next_action: crmNextAction.value,
        crm_next_action_due_date: props.company.crm_next_action_due_date
    })
    const result = await updateCrmNextAction(props.company.id, data, token)
    if(result.status == 200){
        emit('refetch-companies')
        closeCRMEventForm()
    } else {
        $toast.open({
            message: 'Error, could not update CRM Next Action and add event',
            type: 'error',
            duration: 3000
        })
    }
}
</script>

